import toast from "react-hot-toast";

import { nextCargoApi } from "../../baseApi";
import { Companies } from "./company.types";

export const companyApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Get all companies
     * @returns Array of companies with basic information
     */
    getCompanies: build.query<Companies[], void>({
      query: () => "/company",
      onQueryStarted: (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando empresas...",
          success: "Empresas carregadas com sucesso!",
          error: "Erro ao carregar empresas."
        });
      }
    }),

    /**
     * Get a single company by Host
     * @param host - Company host
     * @returns Full company details
     */
    getCompanyByHost: build.query<{ id: number; logo: string; name: string }, { host: string }>({
      query: (params) => ({
        url: "/company/host/",
        params
      })
    })
  })
});

companyApi.enhanceEndpoints({
  addTagTypes: ["CompanyByHost", "Companies"],
  endpoints: {
    getCompanyByHost: {
      providesTags: (result, err, { host }) => [{ type: "CompanyByHost", id: result?.id ?? host }]
    },
    getCompanies: {
      providesTags: (result) =>
        result ? [...result.map(({ id }) => ({ type: "Companies" as const, id })), { type: "Companies", id: "LIST" }] : [{ type: "Companies", id: "LIST" }]
    }
  }
});
